<div class="app-section-title">
  <img
    [alt]="title"
    [src]="icon"
  />
  <div class="app-section-title__title">{{ title | translate }}</div>
</div>
